/**
 * A class describing the most basic user information.
 */
export class UserSummary {
  email: string;

  /**
   * @param email user's email and an identifier of a user.
   */
  constructor(email: string) {
    this.email = email;
  }
}
